var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('institution-picker-dialog',{attrs:{"employee":_vm.employee,"value":_vm.value,"mode":"assign"},on:{"input":function($event){return _vm.$emit('input', $event)},"update:employee":function($event){return _vm.$emit('update:employee')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }